module.exports = __webpack_public_path__ + "static/media/УОМШ-2024-2.7fad891f.pdf";